function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#252C32"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M8.348 8.348l1.579 1.579c-3.179 3.179-4.13 7.96-2.409 12.112 1.72 4.153 5.772 6.862 10.268 6.863h1.767l-2.557-2.546 1.579-1.578 3.657 3.668c.862.867.862 2.268 0 3.135l-3.657 3.668-1.579-1.578 2.557-2.546h-1.767c-5.399.004-10.268-3.246-12.334-8.233-2.067-4.987-.923-10.729 2.896-14.544zM16.996.322l1.579 1.579-2.557 2.545h1.768c5.398-.004 10.267 3.246 12.334 8.234 2.066 4.987.923 10.728-2.897 14.543l-1.578-1.578c3.178-3.18 4.129-7.96 2.408-12.113-1.72-4.153-5.772-6.861-10.267-6.862h-1.768l2.557 2.545-1.579 1.579-3.657-3.669c-.862-.867-.862-2.267 0-3.134L16.996.322z",
  transform: "translate(-688 -2593) translate(688.571 2593)"
}))));

var SvgSwitch = function SvgSwitch(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSwitch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/switch.cd909e21.svg";
export { ForwardRef as ReactComponent };